import { func, string } from 'prop-types';
import React from 'react';
import ActionButton from 'components/ActionButton';

export const AnswerItem = ({ type, id, openDialog }) => (
  <div style={{ marginTop: '1rem' }}>
    <ActionButton
      localeId="npView.history.open"
      onClick={() => openDialog(type, id)}
      border
      secondary
      style={{ height: '4rem', width: '10rem' }}
    />
    <span style={{ marginLeft: '2rem' }}>
      {(type === 'msnq' || type === 'fsmc') && (
        <ActionButton
          localeId="npView.history.infoComponent"
          onClick={() => openDialog(type, id, true)}
          border
          secondary
          style={{ height: '4rem' }}
        />
      )}
    </span>
  </div>
);
AnswerItem.propTypes = {
  type: string,
  id: string,
  openDialog: func,
};
